// full updated code (starts here)
import React, { useState, useEffect } from "react";
import classes from './ActionPaged.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useUser } from "../../UserContext";


const ActionPaged = () => {
  const { user } = useUser();
  const userRole = (user?.role || user?.user_type || user?.account_type || user?.type || '').toLowerCase();
  const isSuperAdmin = userRole === 'super admin' || userRole === 'superadmin' || userRole === 'super_admin';
  const location = useLocation();
  const salesType = location.state?.sales_type || '';
  // const [invoiceItems, setInvoiceItems] = useState([]);
  const [currency, setCurrency] = useState("");
  const [showPrint, setShowPrint] = useState(false);
  const [reference, setReference] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [itemId, setItemId] = useState("");
  const [quantity, setQuantity] = useState("");

  const [currencies, setCurrencies] = useState([]);
  const [responseData, setResponseData] = useState(null);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const [vatRates, setVatRates] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [products, setProducts] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [stores, setStores] = useState([]);
  const [loadingStores, setLoadingStores] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [storeIdToProducts, setStoreIdToProducts] = useState({});
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [type, setType] = useState("products");
  const [transactionDate, setTransactionDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const formatNumberInput = (value) => {
    const raw = value.replace(/,/g, ''); // remove commas
    if (!raw) return '';
    const number = parseFloat(raw);
    if (isNaN(number)) return '';
    return number.toLocaleString();
  };
  const cleanNumber = (value) => {
    const num = parseFloat(String(value).replace(/,/g, ''));
    return isNaN(num) ? "0.00" : num.toFixed(2); // string output
  };

  const [bearer, setBearer] = useState('');

  const readData = async () => {
    try {
      const value = localStorage.getItem('authToken');


      if (value !== null) {
        setBearer(value);
        console.log(value);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      const token = localStorage.getItem("authToken");

      try {
        const [servicesRes, stocksRes] = await Promise.all([
          axios.get(`${BASE_URL}/v1/items/fetch-services`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
          }),
          axios.get(`${BASE_URL}/v1/fetch_stocks`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
          })
        ]);

        if (servicesRes?.data?.status) setServices(servicesRes.data.data);
        if (stocksRes?.data?.status) setStocks(stocksRes.data.data || []);

      } catch (error) {
        console.error("Error fetching services/stocks:", error);
      }
    };

    fetchItems();
  }, []);
  // Fetch stores for Super Admins
  useEffect(() => {
    const fetchStores = async () => {
      if (!isSuperAdmin) return;
      setLoadingStores(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/store`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
        });
        let storesData = res.data?.data?.data || res.data?.data || res.data;
        if (!Array.isArray(storesData)) storesData = [];
        const normalizedStores = storesData.map(s => ({ id: s.id ?? s.store_id ?? s.value, name: s.name ?? s.store_name ?? s.title ?? `Store ${s.id ?? s.store_id}` }));
        setStores(normalizedStores);
      } catch (err) {
        console.error("Error fetching store products:", err);
        setStores([]);
      } finally {
        setLoadingStores(false);
      }
    };

    fetchStores();
  }, [isSuperAdmin]);

  // When a store is selected by Super Admin, fetch only that store's products
  useEffect(() => {
    const fetchStoreProducts = async () => {
      if (!isSuperAdmin) return; // Staff keeps original stocks
      if (!selectedStoreId) {
        setStocks([]);
        // Clear any previously selected product lines that don't exist anymore
        setInvoiceItems(prev => prev.map(row => {
          const cleared = { ...row, ledger: "", item_id: undefined, description: "", price: 0 };
          return recomputeRow(cleared, "price");
        }));
        return;
      }
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get_store_products`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
          params: { store_id: selectedStoreId }
        });
        const raw = res.data?.data?.data || res.data?.data || res.data;
        const list = Array.isArray(raw) ? raw : [];
        const normalized = list.map((p) => ({
          id: p?.id,
          name: p?.name || p?.product_name || p?.title || `Product ${p?.id || ''}`,
          price: p?.price || p?.unit_price || 0,
          description: p?.description || ''
        }));
        setStocks(normalized);

        // Clear any invoice lines whose product no longer exists in the new store
        const allowedIds = new Set(normalized.map(p => p.id));
        const allowedNames = new Set(normalized.map(p => p.name));
        setInvoiceItems(prev => prev.map(row => {
          const hasIdMismatch = row.item_id && !allowedIds.has(row.item_id);
          const hasNameMismatch = row.ledger && !allowedNames.has(row.ledger);
          if (hasIdMismatch || hasNameMismatch) {
            const cleared = { ...row, ledger: "", item_id: undefined, description: "", price: 0 };
            return recomputeRow(cleared, "price");
          }
          return row;
        }));
      } catch (err) {
        console.error("Error fetching products for store:", err);
        setStocks([]);
        // On error, also clear product selections to avoid inconsistent state
        setInvoiceItems(prev => prev.map(row => {
          const cleared = { ...row, ledger: "", item_id: undefined, description: "", price: 0 };
          return recomputeRow(cleared, "price");
        }));
      }
    };

    fetchStoreProducts();
  }, [isSuperAdmin, selectedStoreId]);


  const [items, setItems] = useState([
    { ledger: "", qty: 1, price: 0, discount: 0, discountRate: 0, vat: 0, description: "", total: 0 }
  ]);

  const [invoiceItems, setInvoiceItems] = useState([
    {
      type: "product",
      ledger: "",
      description: "",
      userEditedDescription: false,
      qty: 1,
      price: 0,
      discountRate: "",     // % (string so empty = no default 0)
      discountAmount: "",   // money (string so empty = no default 0)
      discount: 0,          // internal computed discount used in totals
      vatRate: "Premium",
      vat: 0,
      wht: 0,
      total: 0
    }
  ]);

  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await axios.get(`${BASE_URL}/v1/customer`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };
    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const [servicesRes, productsRes] = await Promise.all([
          axios.get(`${BASE_URL}/v1/items/fetch-services`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json"
            }
          }),
          axios.get(`${BASE_URL}/v1/items/fetch-products`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json"
            }
          })
        ]);
        if (servicesRes?.data?.status) setServices(servicesRes.data.data);
        if (productsRes?.data?.status) setProducts(productsRes.data.data);
      } catch (error) {
        console.error("Error fetching services/products:", error);
      }
    };
    fetchItems();
  }, []);


  const fetchInitialData = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const [refRes, currencyRes] = await Promise.all([
        axios.get(`${BASE_URL}/v1/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }),
        axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }),
      ]);
      if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    if (bearer)
      fetchInitialData();
  }, [bearer]);

  const handleProductSelect = (rowIndex, productName) => {
    setItems(prevItems => {
      const updatedItems = [...prevItems];
      // const selectedProduct = stocks.find(p => p.name === productName);
      const selectedProduct = Array.isArray(stocks)
        ? stocks.find(p => p.name === productName)
        : undefined;


      updatedItems[rowIndex].ledger = productName;
      if (selectedProduct) {
        updatedItems[rowIndex].price = selectedProduct.price; // auto-fill price
      }
      return updatedItems;
    });
  };




  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        type: type === "products" ? "product" : "service",
        ledger: "",
        description: "",
        userEditedDescription: false,
        qty: 1,
        price: 0,
        discountRate: "",
        discountAmount: "",
        discount: 0,
        vatRate: "Premium",
        vat: 0,
        wht: 0,
        total: 0
      }
    ]);
  };


  useEffect(() => {
    const fetchVatRates = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await axios.get(`https://api-sme.promixaccounting.com/api/v1/taxes/company-tax`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res?.data?.status && Array.isArray(res.data.data)) {
          setVatRates(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch VAT rates:", error);
      }
    };

    fetchVatRates();
  }, []);

  const handleDeleteRow = (index) => {
    const updated = [...invoiceItems];
    updated.splice(index, 1);
    setInvoiceItems(updated);
  };
  const clampPct = (v) => {
    const n = parseFloat(v);
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(100, n));
  };

  const toNumber = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  const recomputeRow = (row, changedField) => {
    const qty = toNumber(row.qty);
    const price = toNumber(row.price);
    const lineAmount = qty * price;

    // Start with raw inputs
    let pct = row.discountRate;
    let amt = row.discountAmount;

    if (changedField === "discountRate") {
      // user edited percent → compute amount
      const p = clampPct(pct);
      amt = lineAmount ? ((p / 100) * lineAmount) : 0;
      row.discountRate = pct === "" ? "" : p; // keep empty if user cleared
      row.discountAmount = pct === "" ? "" : +amt.toFixed(2);
    } else if (changedField === "discountAmount") {
      // user edited amount → compute percent
      const a = Math.max(0, Math.min(lineAmount, toNumber(amt)));
      pct = lineAmount ? (a / lineAmount) * 100 : 0;
      row.discountAmount = amt === "" ? "" : +a.toFixed(2);
      row.discountRate = amt === "" ? "" : +pct.toFixed(2);
    } else {
      // qty/price/other changed → keep them consistent
      if (row.discountRate !== "" && lineAmount) {
        const p = clampPct(row.discountRate);
        row.discountAmount = +((p / 100) * lineAmount).toFixed(2);
        row.discountRate = p;
      } else if (row.discountAmount !== "" && lineAmount) {
        const a = Math.max(0, Math.min(lineAmount, toNumber(row.discountAmount)));
        row.discountRate = +((a / lineAmount) * 100).toFixed(2);
        row.discountAmount = +a.toFixed(2);
      } else {
        row.discountRate = row.discountRate === "" ? "" : 0;
        row.discountAmount = row.discountAmount === "" ? "" : 0;
      }
    }

    // Effective discount is amount
    const discount = toNumber(row.discountAmount);
    const taxable = Math.max(0, lineAmount - discount);

    row.discount = discount;
    row.vat = row.tax_id === 1 ? 0.075 * taxable : 0;
    row.wht = row.wht_id === 2 ? 0.02 * taxable : 0;
    row.total = taxable + row.vat + row.wht;

    return row;
  };


  const handleChange = (index, field, value) => {
    setInvoiceItems(prev => {
      const updated = [...prev];
      const row = { ...updated[index], [field]: value };
      if (field === 'description') {
        row.userEditedDescription = true;
      }

      if (field === "ledger") {
        const selectedItem = Array.isArray(stocks)
          ? stocks.find(item => item.name === value)
          : undefined;
        if (selectedItem) {
          row.price = parseFloat(selectedItem.price || selectedItem.cost_price || 0);
          row.item_id = selectedItem.id;
          // Auto-fill description for products, or when the user hasn't
          // manually edited the description for services.
          if (type === "products" || !row.userEditedDescription) {
            row.description = selectedItem.description || "";
          }
        } else {
          // Reset values when no item is selected. Only clear description
          // if the user hasn't manually provided one.
          row.price = 0;
          row.item_id = undefined;
          if (!row.userEditedDescription) row.description = "";
        }
      }

      if (field === "vatChecked") row.tax_id = value ? 1 : null;
      if (field === "wthChecked") row.wht_id = value ? 2 : null;

      // Recalc with awareness of which field changed
      updated[index] = recomputeRow(row, field);
      return updated;
    });
  };



  const subtotal = invoiceItems.reduce((acc, it) => acc + (it.qty * it.price - it.discount), 0);
  const totalVAT = invoiceItems.reduce((acc, it) => acc + it.vat, 0);
  const totalWHT = invoiceItems.reduce((acc, it) => acc + (it.wht || 0), 0);
  const grandTotal = subtotal + totalVAT + totalWHT;

  const handleSaveInvoice = async () => {
    const token = localStorage.getItem("authToken");

    if (!reference || !currency || !selectedCustomerId || invoiceItems.length === 0) {
      Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
      return;
    }

    const item_id = [];
    const quantity = [];
    const item_amount = [];
    const referencePerItem = [];
    const tax_id = [];
    const wht_id = [];
    const discount = [];
    const discount_percentage = [];

    let sub_total = 0;
    let total_discount = 0;
    let total_vat = 0;
    let total_wht = 0;

    invoiceItems.forEach((row) => {
      const qty = Number(row.qty) || 0;
      const price = Number(row.price) || 0;
      const lineAmount = qty * price;
      const discountAmt = Number(row.discount) || 0;
      const taxable = Math.max(0, lineAmount - discountAmt);

      const vat = Number(row.vat) || 0;
      const wht = Number(row.wht) || 0;

      item_id.push(row.item_id);
      quantity.push(qty);
      item_amount.push(+lineAmount.toFixed(2));
      referencePerItem.push(String(row.description ?? "").trim());
      tax_id.push(row.tax_id ?? null);
      wht_id.push(row.wht_id ?? null);
      discount.push(discountAmt > 0 ? +discountAmt.toFixed(2) : null);

      const pct = row.discountRate === "" ? null : Number(row.discountRate);
      discount_percentage.push(pct && pct > 0 ? +pct.toFixed(2) : null);

      sub_total += taxable;
      total_discount += discountAmt;
      total_vat += vat;
      total_wht += wht;
    });

    const grand_total = sub_total + total_vat + total_wht;

    const payload = {
      sales_type: salesType,
      invoice_number: reference,
      customer_id: selectedCustomerId,
      transaction_date: transactionDate,   // ✅ include if required
      due_date: dueDate,
      currency: currency,
      description: "credit sales",
      item_id,
      quantity,
      item_amount,
      reference: referencePerItem,
      tax_id,
      wht_id,
      discount,
      discount_percentage,
      sub_total: +sub_total.toFixed(2),
      total_discount: +total_discount.toFixed(2),
      total_vat: +total_vat.toFixed(2),
      total_wht: +total_wht.toFixed(2),
      amount: +grand_total.toFixed(2),
      total_price: +grand_total.toFixed(2),
      ...(isSuperAdmin && selectedStoreId ? { store_id: selectedStoreId } : {})
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/v1/sales_to_customer`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      setResponseData(res?.data?.data);
      Swal.fire("Success", "Invoice saved successfully!", "success");
      setShowPrint(true);
      fetchInitialData();

      // Reset invoice to one blank row
      setInvoiceItems([
        {
          type: "product",
          ledger: "",
          description: "",
          qty: 1,
          price: 0,
          discountRate: "",
          discountAmount: "",
          discount: 0,
          vatRate: "Premium",
          vat: 0,
          wht: 0,
          total: 0
        }
      ]);
    } catch (error) {
      const msg = error?.response?.data?.message || "Submission failed!";
      Swal.fire("Failed", JSON.stringify(msg), "error");
    } finally {
      setIsSaving(false);
    }
  };







  const totalDiscount = invoiceItems.reduce((sum, item) => sum + (item.discount || 0), 0);
  const totalVat = invoiceItems.reduce((sum, item) => sum + (item.vat || 0), 0);
  const totalWht = invoiceItems.reduce((sum, item) => sum + (item.wht || 0), 0);  // ✅ new
  const totalAmount = invoiceItems.reduce((sum, item) => sum + (item.total || 0), 0);

  const handlePrintReceipt = () => {
    navigate("/printreceipts", {
      state: {
        responseData
      },
    });

  }
  const handlePOSReceipt = () => {
    navigate("/pos_receipt", {
      state: {
        result: responseData,
        mode: "pos",
      },
    });

  };
  console.log(responseData);

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>New Customer Credit</h2>
        </header>
        <form className={classes.form}>
          {isSuperAdmin && (
            <div className={classes.group1}>
              <label>Store</label>
              <Select
                isClearable
                isSearchable
                isDisabled={loadingStores}
                placeholder={loadingStores ? 'Loading stores...' : 'Select store'}
                options={stores.map((store) => ({
                  value: String(store.id),
                  label: store.name || `Store ${store.id}`
                }))}
                value={(() => {
                  const options = stores.map((store) => ({
                    value: String(store.id),
                    label: store.name || `Store ${store.id}`
                  }));
                  return options.find(o => o.value === String(selectedStoreId)) || null;
                })()}
                onChange={(option) => setSelectedStoreId(option?.value || "")}
              />
            </div>
          )}
          <div className={classes.group}>
            <label>Customer Name*</label>
            <input
              type="text"
              placeholder="Search or type customer"
              value={selectedCustomerName}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedCustomerName(value);
                const match = customers.find(c => c.name.toLowerCase() === value.toLowerCase());
                setSelectedCustomerId(match ? match.id : ""); // store ID if matched
              }}
              list="customerList"
              required
            />
            <datalist id="customerList">
              {customers.map(cust => (
                <option key={cust.id} value={cust.name} />
              ))}
            </datalist>
          </div>

          <div className={classes.group1}>
            <label>Invoice Date</label>
            <input type="date" value={transactionDate} onChange={(e) => setTransactionDate(e.target.value)} required />
          </div>
          <div className={classes.group1}>
            <label>Due Date</label>
            <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required />
          </div>
          <div className={classes.group2}>
            <label>Reference</label>
            <input type="text" value={reference} readOnly />
          </div>
          <div className={classes.group1}>
            <label>Currency</label>
            <input
              type="text"
              placeholder="Search or type currency"
              value={selectedCurrencyText}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedCurrencyText(value);
                const match = currencies.find(c =>
                  `${c.symbol} ${c.code} - ${c.country}`.toLowerCase() === value.toLowerCase()
                );
                setCurrency(match ? match.id : ""); // store ID if matched
              }}
              list="currencyList"
              required
            />
            <datalist id="currencyList">
              {currencies.map(cur => (
                <option
                  key={cur.id}
                  value={`${cur.symbol} ${cur.code} - ${cur.country}`}
                />
              ))}
            </datalist>
          </div>
        </form>

        <div className={classes.invoicecont}>
          <div style={{ marginBottom: "1rem" }}>
            <button type="button" className={type === "products" ? classes.activeTab : classes.inactiveTab} onClick={() => setType("products")}>Products</button>
            <button type="button" className={type === "services" ? classes.activeTab : classes.inactiveTab} onClick={() => setType("services")}>Services</button>
          </div>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>Product / Services</th>
                <th>Description</th>
                <th>Qty/Hrs*</th>
                <th>Price/Rate*</th>
                <th>Discount(%)</th>
                <th>Discount Amount</th>
                <th>VAT</th>
                <th>WHT</th>
                <th>Total</th>
                <th><button type="button" className={classes.addRowBtn} onClick={handleAddRow}>+</button></th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.map((item, idx) => (
                <tr key={idx}>
                  <td className={classes.productCell}>
                    <input
                      list={`stockList-${idx}`}
                      value={item.ledger}
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        // const selectedStock = stocks.find(stock => stock.name === selectedName);
                        const selectedStock = Array.isArray(stocks)
                          ? stocks.find(stock => stock.name === selectedName)
                          : undefined;

                        handleChange(idx, 'ledger', selectedName); // store name for UI
                        if (selectedStock) {
                          handleChange(idx, 'price', selectedStock.price); // fetch from API
                          handleChange(idx, 'item_id', selectedStock.id); // store item_id for API
                        }
                      }}
                      placeholder="Search or type stock item"
                    />
                    <datalist id={`stockList-${idx}`}>
                      {Array.isArray(stocks) && stocks.map(stock => (
                        <option key={stock.id} value={stock.name}>
                          {stock.name}
                        </option>
                      ))}

                    </datalist>
                  </td>

                  <td className={classes.descriptionCell}>
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) => handleChange(idx, 'description', e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) => handleChange(idx, "qty", e.target.value)}
                      placeholder="Qty/Hrs*"
                      required
                    />
                  </td>


                  <td>
                    <input
                      type="number"
                      value={item.price}
                      onChange={(e) => handleChange(idx, "price", e.target.value)}
                      placeholder="Price/Rate*"
                      required
                      className={classes.totalInput}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      min={0}
                      max={100}
                      step="0.01"
                      value={item.discountRate === "" ? "" : item.discountRate}
                      onChange={(e) => handleChange(idx, "discountRate", e.target.value)}
                      placeholder="%"                // no default 0
                      className={classes.discountInput}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      step="0.01"
                      value={item.discountAmount === "" ? "" : item.discountAmount}
                      onChange={(e) => handleChange(idx, "discountAmount", e.target.value)}
                      placeholder="0.00"             // no default value; hint only
                      className={classes.totalInput}
                    />
                  </td>

                  <td>
                    <input
                      type="checkbox"
                      checked={item.vatChecked || false}
                      onChange={(e) => handleChange(idx, 'vatChecked', e.target.checked)}
                    />
                  </td>
                  {/* <td>
                    <select value={item.vatRate} onChange={(e) => handleChange(idx, 'vatRate', e.target.value)}>
                      <option value="">Select VAT</option>
                      {vatRates.map((rate) => (
                        <option key={rate.id} value={rate.rate}>
                          {rate.description} - {rate.rate}%
                        </option>
                      ))}
                    </select>

                  </td> */}
                  {/* <td><input type="number" value={item.vat.toFixed(2)} readOnly className={classes.vatInput} /></td> */}
                  <td>
                    <input
                      type="checkbox"
                      checked={item.wthChecked || false}
                      onChange={(e) => handleChange(idx, 'wthChecked', e.target.checked)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={Number(item.total).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      readOnly
                      className={classes.totalInput}
                    />
                  </td>



                  <td><Trash2 size={16} onClick={() => handleDeleteRow(idx)} className={classes.deleteIcon} /></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>

          <div className={classes.foot}>
            <div className={classes.Footer}>
              <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Comments</label>
                <textarea className={classes.commentsBox}></textarea>
              </div>
              <div className={`${classes.footerSection} ${classes.policies}`}>
                <label>Policies and guidelines</label>
                <textarea className={classes.policiesBox}></textarea>
              </div>
              <div className={`${classes.footerSection} ${classes.summary}`}>
                <div className={classes.shipping}>
                  <label>Shipping</label>
                  <select><option>Standard (UK)</option></select>
                  <input type="text" defaultValue="0.00" readOnly />
                </div>
                <div className={classes.totals}>
                  <div className={classes.totalRow}>
                    <span>Subtotal:</span>
                    <span>
                      {(() => {
                        const selected = currencies.find(c => c.id === currency);
                        return selected ? `${selected.symbol} ` : "";
                      })()}
                      {subtotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                  </div>

                  <div className={classes.totalRow}>
                    <span>W.H.T:</span>
                    <span>
                      {(() => {
                        const selected = currencies.find(c => c.id === currency);
                        return selected ? `${selected.symbol} ` : "";
                      })()}
                      {totalWHT.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className={classes.totalRow}>
                    <span>VAT (7.5%):</span>
                    <span>
                      {(() => {
                        const selected = currencies.find(c => c.id === currency);
                        return selected ? `${selected.symbol} ` : "";
                      })()}
                      {totalVAT.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className={classes.totalRow}>
                    <span>Total Discount:</span>
                    <span>
                      {(() => {
                        const selected = currencies.find(c => c.id === currency);
                        return selected ? `${selected.symbol} ` : "";
                      })()}
                      {totalDiscount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className={`${classes.totalRow} ${classes.total}`}>
                    <span>Total:</span>
                    <strong>
                      {(() => {
                        const selected = currencies.find(c => c.id === currency);
                        return selected ? `${selected.symbol} ` : "";
                      })()}
                      {grandTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </strong>
                  </div>

                </div>
                <div className={classes.actionButtons}>
                  <button className={classes.cancelButton}>Cancel</button>
                  <button
                    className={classes.saveButton}
                    type="button"
                    onClick={handleSaveInvoice}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ActionPaged;
